// src/hooks/useWeb3.js

import { useState } from 'react';
import web3Service from '../Services/web3Services';

const useWeb3 = () => {
  const [account] = useState(null);

  return {
    web3: web3Service.getWeb3(),
    isReady: web3Service.isReady,
    chainId: 97,
    account,
    isConnected: !!account
  };
};

export default useWeb3;